






















import { Component, Vue, Model, Emit } from "vue-property-decorator";
import { FileService } from "@/services/fileService";

@Component
export default class EventDescriptionEditor extends Vue {
    @Model() public model!: string;

    @Emit() public editorClose() {
        return;
    }

    public rightToolbar: string = "preview toc sync-scroll";

    public get description() {
        return this.model;
    }

    public set description(value: string) {
        this.$emit("model", value);
    }

    public handleUploadImage(
        event: Event,
        insertImage: Function,
        files: File[]
    ) {
        FileService.uploadFile("event", files[0]).then(response => {
            insertImage({
                url: `/api/file/by_id/${response.data.id}`,
                desc: response.data.filename,
                width: "300",
                height: "300",
            });
        });
    }
}
